
































import {Component, Vue} from "vue-property-decorator";
import RefuelingEntry from "@/components/RefuelingEntry.vue";
import HistoryChart from "@/components/HistoryChart.vue";
import {RefuelingHistoryEntry} from "@/types/refuelingEvent";
import Total from "@/components/Total.vue";

@Component({
  components: {RefuelingEntry, HistoryChart, Total}
})
export default class Statistic extends Vue {
  selectedTags:string[] = [];

  get refuelings(): RefuelingHistoryEntry[] {
    if (this.selectedTags.length == 0) {
      return [...this.$store.state.refuelings];
    }
    let r : RefuelingHistoryEntry[] = [];
    if (this.selectedTags.includes("this-year")) {
      r = this.refuelingsFor(new Date().getFullYear());
    }
    if (this.selectedTags.includes("last-year")) {
      const lastYear = this.refuelingsFor(new Date().getFullYear() - 1);
      r = r.concat(lastYear);
    }
    return r;
  }

  refuelingsFor(year: number): RefuelingHistoryEntry[] {
    return [...this.$store.state.refuelings].filter((x: RefuelingHistoryEntry) => x.date.getFullYear() == year);
  }
}
